import SlotMachine from './modules/SlotMachine';
import Parallax from './modules/Parallax';
import LazyLoad from 'lazyload';
import MicroModal from 'micromodal'; 

class App {
    
    constructor(options) {
        this.options = options || {};

        this.node = {
            gameButton: document.querySelector('.js-game-button'),
            slotMachine: document.querySelector('.js-slot-machine'),
            headline: document.querySelector('.js-headline'),
            spiner: document.querySelector('.js-spiner'),
        };

        this.class = {
            modalContainer: 'modal__container',
            hideSpiner: 'slot-table__spiner--hide'
        };

        this.state = {
            spinCounter: 1,
            activeGame: false
        };

        this.winModalID = 'modal-win';
        this.firstGameTimeout = 2000;
        this.slotMachine = new SlotMachine();

        this.init();
    }

    init() {
        this.node.gameButton.addEventListener('click', (e) => {
            if (this.state.spinCounter > 0) {
                e.preventDefault();
            }

            this.startGame();
        });

        window.addEventListener('DOMContentLoaded', () => {
            setTimeout(() => this.startGame(), this.firstGameTimeout);

            this.lazyLoad();
            this.microModal();
            this.parallax();


            setTimeout(() => {
                this.node.spiner.classList.add(this.class.hideSpiner);
            }, 800);
        });
        
        window.addEventListener('wheelGame', (e) => this.gameHandler(e));
    }

    lazyLoad() {
        let images = document.querySelectorAll('.js-lazyload');
        new LazyLoad(images);
    } 

    microModal() {
        MicroModal.init();
    }

    showWinModal() {
        let slotMachieRect = this.node.slotMachine.getBoundingClientRect();
        
        document.querySelector('.' + this.class.modalContainer).style.top = slotMachieRect.y + 'px';

        try {
            MicroModal.show(this.winModalID);
        } catch (e) {

        }
    }

    parallax() {
        new Parallax({
            wrapper: '.js-bg-wrapper',
            layers: '.js-bg-layer',
            deep: 'data-parallax-deep'
        });
    }

    startGame() {
        if (!this.state.activeGame) {
            this.state.activeGame = true;
            this.node.gameButton.disabled = true;

            if (this.state.spinCounter > 0) {
                this.slotMachine.start();
            }
        }
    }

    endGame() {
        this.state.activeGame = false;
        this.node.gameButton.disabled = false;
        this.state.spinCounter--;

        // setTimeout(() => {
        //     this.node.headline.classList.add('pulse');
        // }, 4500);

        setTimeout(() => {
            this.showWinModal();
        }, 4500);
    }

    gameHandler(event) {

        switch (event.detail.status) {
            case 'begin':
                this.startGame();
                break;
            case 'complete':
                this.endGame();
                break;
            case 'rotation':
                console.log('The slot machine is worked');
                break;
        }
    }
}

new App();